import React, { useId } from 'react';
import P from '@hero/ui-kit/typography/P';
import useTheme from '@hero/branding/theme';
import { MarkSelect, MarkLabel } from '../../../components/MarkControls';
import useAllSegments from '../../../api/useAllSegments';
import type { SegmentTargetKind } from '../../../types';
import * as styles from './style.module.css';

type Props = {
    value: number | null;
    onChange: (value: number | null) => void;
    targetKind: SegmentTargetKind | '';
    excludeId?: number;
    // The API treats a null source as no change, so an existing chain cannot be removed.
    lockedSource?: boolean;
};
const SourceSegmentSelect: React.FC<Props> = ({
    value,
    onChange,
    targetKind,
    excludeId,
    lockedSource = false
}) => {
    const id = useId();
    const { colors } = useTheme();
    const { data: segments = [] } = useAllSegments();
    const filtered = segments.filter(
        (segment) => segment.target_kind === targetKind && segment.segment_id !== excludeId
    );
    return (
        <div className={styles.field} style={{ marginTop: '2.4rem' }}>
            <MarkLabel htmlFor={id} style={{ margin: 0 }}>
                Start from an existing segment (optional)
            </MarkLabel>
            <MarkSelect
                id={id}
                value={value ?? ''}
                disabled={!targetKind}
                aria-describedby={`${id}-hint`}
                onChange={(event) =>
                    onChange(event.currentTarget.value ? Number(event.currentTarget.value) : null)
                }
                style={{ width: '100%' }}
            >
                <option value="" disabled={lockedSource}>
                    {targetKind ? 'No starting segment' : 'Choose an audience type first'}
                </option>
                {filtered.map((segment) => (
                    <option key={segment.segment_id} value={segment.segment_id}>
                        {segment.name}
                    </option>
                ))}
            </MarkSelect>
            <P
                id={`${id}-hint`}
                noDefaultMargin
                size="small"
                styles={{ color: colors.neutrals.textBeta }}
            >
                {lockedSource
                    ? 'You can switch the starting segment, but a saved chain cannot be removed.'
                    : 'Only records in the starting segment will be considered. Your filters narrow that audience further.'}
            </P>
        </div>
    );
};
export default SourceSegmentSelect;
